<template>
    <!--<div>-->
        <!--<div class="smart-main-search-container flex flex-wrap">-->
            <!--&lt;!&ndash;<div class="w-180 mr-10">&ndash;&gt;-->
            <!--&lt;!&ndash;<el-input v-model="searchParams.userName" placeholder="请输入用户名"></el-input>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="w-180 mr-10">&ndash;&gt;-->
            <!--&lt;!&ndash;<el-input v-model="searchParams.userNo" placeholder="请输入用户编号"></el-input>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="w-180 mr-10">&ndash;&gt;-->
            <!--&lt;!&ndash;<el-input v-model="searchParams.tel" placeholder="请输入用户电话"></el-input>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->

            <!--&lt;!&ndash;<div class="w-180 mr-10">&ndash;&gt;-->
            <!--&lt;!&ndash;<el-input v-model="searchParams.conNo" placeholder="请输入集中器号"></el-input>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->

            <!--<div class="w-180 mr-10">-->
                <!--<date-picker v-model="searchParams.startDateStr" value-format="yyyy-MM-dd" placeholder="请选择开始时间"></date-picker>-->
            <!--</div>-->
            <!--<div class="w-180 mr-10">-->
                <!--<date-picker v-model="searchParams.endDateStr" value-format="yyyy-MM-dd" placeholder="请选择结束时间"></date-picker>-->
            <!--</div>-->
            <!--<div class="flex-1"></div>-->
            <!--<div class="flex">-->
                <!--<load-button  class="mr-10" @on-click="search"></load-button>-->
                <!--<el-button type="primary" @click="add" plain>新增监控</el-button>-->
            <!--</div>-->
        <!--</div>-->
    <!--</div>-->
    <div>
        <div class="smart-main-search-container flex flex-wrap">



            <div class="flex-1"></div>
            <div class="flex">
                <el-button type="primary" @click="add" plain>新增监控协议</el-button>
            </div>


        </div>

        <div class="content mt-20">
            <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
        </div>

        <div class="flex flex-right mt-20">
            <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
        </div>
        <form-dialog ref="model" title="公司信息" @on-confirm="save">
            <div slot="dialog-main">
                <el-form>
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="名称" label-width="160px">
                                <el-input v-model="temp.name"></el-input>
                            </el-form-item>
                        </div>


                    </div>
                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="编码" label-width="160px">
                                <el-input v-model="temp.dataCode"></el-input>
                            </el-form-item>
                        </div>


                    </div>

                    <div class="flex flex-mid">
                        <div class="flex-1">
                            <el-form-item label="格式" label-width="160px">
                                <el-input v-model="temp.formatCode"></el-input>
                            </el-form-item>
                        </div>


                    </div>





                </el-form>
            </div>
        </form-dialog>
    </div>
</template>

<script>
    import LoadButton from "../../components/LoadButton";
    import Pagination from "../../components/Pagination";
    import SmartTable from "../../components/SmartTable";
    import FormDialog from "../../components/FormDialog";
    import UploadImg from "../../components/UploadImg";
    import Dropdown from "../../components/Dropdown";
    import UploadButton from "../../components/UploadButton";
    export default{
        components: {
            Dropdown,
            UploadImg,
            FormDialog,
            SmartTable,
            Pagination,
            LoadButton,
            UploadButton
        },
        data(){
            return {
                searchParams: {
                    page: 1
                },
                searchData: {},
                opt: [
                    {label:'编辑',fn:this.getDetail},
                    {label:'删除',fn:this.del}
                ],
                labels: [
                    {prop: 'name', label: '公司名称'},
                    {prop: 'dataCode', label: '编码'},
                    {prop: 'formatCode', label: '格式'},

                ],
                temp:{}
            }
        },
        computed:{
            list(){
                let  arr = []
                for(var i in this.$store.state.tasKeyMap){
                    arr.push({id:i,name:this.$store.state.tasKeyMap[i]})
                }
                return arr
            },
        },
        mounted(){
            this.getList()
        },
        methods: {

            toPage(page){
                this.searchParams.page = page
                this.getList()
            },
            getList(callback){
                this.$http$({method: 'get', url: "/smartMeter/meterProtocol",data:this.searchParams,  load: 1}, (data) => {
                    callback ? callback() : ''
                    this.searchData = data
                })
            },
            getDetail(obj){
                this.temp = JSON.parse(JSON.stringify(obj))
                this.$refs.model.show()
            },
            add(){
                this.temp = {}
                this.$refs.model.show()
            },
            save(){
                this.temp.rate1 = this.temp.step1
                let method = 'post',url='/smartMeter/meterProtocol',msg = '新增监控协议成功！'
                if(this.temp.id){
                    method = "put"
                    // url = '/smartMeterServer/price/update'
                    msg = '修改公司信息成功！'
                }
                this.$http$({method:method,url:url,data:this.temp},(data) => {
                    this.getList()
                    this.$success(msg)
                })

            },
            del(obj){
                this.$fnConfirm('确认删除？',() => {
                    this.$http$({method: 'delete', url: "/smartMeter/meterProtocol/"+obj.id}, (data) => {
                        // callback ? callback() : ''
                        // this.searchData = data
                        this.getList();
                    })
                });


            }
        }
    }
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/pages/superAdmin/MeterProtocol.vue